import React from 'react';
import priceFetcherUpdateStore from './priceFetcherUpdateStore';

// You can add more stores to this object
export const stores = {
  priceFetcherUpdateStore,
};

// Create a context to pass stores through component tree
export const StoreContext = React.createContext(stores);

// Create a custom hook to use the stores
export const useStores = () => React.useContext(StoreContext);
